import { isCondensedCheckoutExcluded } from '../components/EventDetails/ConversionBarContainer/isCondensedCheckoutExcluded';
import { useTicketContext } from '../contexts';

export const useCondensedCheckout = () => {
    const {
        ticketData: { compactCheckoutDisqualifications },
    } = useTicketContext();

    const isTicketSelectionExcluded = isCondensedCheckoutExcluded({
        isRsvp: compactCheckoutDisqualifications.is_rsvp,
    });

    return !isTicketSelectionExcluded;
};
